<div class="container">
    <div class="delete_header">
        <h4>Delete Account</h4>
        <mat-divider></mat-divider>
    </div>
    <p>Are you sure you want to Delete your account?</p>
    <div class="delete_btns">
        <button class="yes_btn" (click)="deleteAccount()" >Yes</button>
        <button class= "no_btn" (click)="backProfile()" >NO</button> 
    </div>
</div>
